import util from '@/utils/index'
const mutations = {
    // 用于action成功后设置数据,数据不会被处理
    set(state, params) {
        state[params.name] = params.data;
    },
    chinaAddress(state, data) {
        state.chinaAddress = util.array2Tree(data, null, 'value', 'parent');
    }
}
export default mutations